import { useAppbarTitle } from '@hooks/useAppbarTitle';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Button, Container } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { OffersList } from '../components';
import { useSpecialistOffersStore } from '../services';
import { OfferStatus } from '../types';

export const OffersListPage: React.FC = () => {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();

	useAppbarTitle('express');
	usePageTitle(t('express'));

	const { status, setStatus } = useSpecialistOffersStore();

	const [searchParams, setSearchParams] = useSearchParams();

	// Initialize status from URL param or default to 'active'
	useEffect(() => {
		const statusParam = searchParams.get('status') as OfferStatus | null;
		if (statusParam && ['active', 'archived', 'completed'].includes(statusParam)) {
			setStatus(statusParam);
		} else if (status) {
			// Update URL with current status if not already set
			searchParams.set('status', status);
			setSearchParams(searchParams);
		}
	}, [searchParams, setSearchParams, setStatus, status]);

	const handleStatusChange = (newStatus: OfferStatus) => {
		searchParams.set('status', newStatus);
		setSearchParams(searchParams);
	};

	const handleGoBack = () => {
		navigateWithLanguage('/specialist/view-offers');
	};

	return (
		<Container maxWidth="lg">
			<Box className="py-6">
				<Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
					<Button
						className="w-[120px]"
						onClick={handleGoBack}
						variant="text"
						sx={{ backgroundColor: 'white', color: 'black' }}
						startIcon={<Icon path={mdiArrowLeft} size={1} />}
					>
						{t('back')}
					</Button>
				</Box>
				<OffersList status={status} onStatusChange={handleStatusChange} />
			</Box>
		</Container>
	);
};
